// TODO: Refactor this file. it's been implemented in a strange way! why debouncer? why not proper debouncing

import React from 'react';
import headerActions from '../../../actions/header';
import Category from './category';
import MoreBtn from './more';
import CustomNavigationItem from '../customnavigationitems';

export default class MajorCategories extends React.Component {
  static propTypes = {
    isLogoLoaded:          React.PropTypes.bool,
    panel:                 React.PropTypes.string,
    activeCategory:        React.PropTypes.number,
    categories:            React.PropTypes.array,
    maxVisibleCategories:  React.PropTypes.number,
    customNavigationItems: React.PropTypes.array
  };

  state = {
    isChanging: true,
    hasMore:    false
  };

  componentDidMount () {
    this._isMounted = true;
    setTimeout(this.calculateSizes, 300);
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount () {
    this._isMounted = false;
    window.removeEventListener('resize', this.onResize);
  }

  componentWillUpdate (nextProps) {
    if (this.props.isLogoLoaded !== nextProps.isLogoLoaded) {
      setTimeout(this.calculateSizes, 100);
    }
  }

  debouncer = null;

  onResize = () => {
    this.setState({isChanging: true});
    clearTimeout(this.debouncer);
    this.debouncer = setTimeout(this.calculateSizes, 200);
  };

  calculateSizes = () => {
    if (this._isMounted) {
      // get the hidden div
      const hiddenDIV = this.refs['hiddenDIV'];
      const menuElements = hiddenDIV.getElementsByTagName('li');

      // set aside the limit
      const wrapperDIV = this.refs['wrapperDIV'];
      const maxSize = wrapperDIV.getBoundingClientRect().width;
      const sizes = [];

      // loop over the elements and transform into an array of sizes
      for (let i = 0; i < menuElements.length; ++i) {
        sizes.push(menuElements[i].getBoundingClientRect().width);
      }
      // take away the size of the more button
      const MoreBtnSize = sizes.shift() + 30;

      const howManyFitWithoutMoreBtn = this.howManyFit(0, maxSize, sizes);

      // they all fit in view, no need of the more btn
      if (howManyFitWithoutMoreBtn === sizes.length) {
        // done calculating
        this.setState({
          isChanging: false,
          hasMore:    false
        });
        headerActions.toggleMaxVisibleCategories(howManyFitWithoutMoreBtn, false);
      }
      else {
        const howManyFitIncludingMoreBtn = this.howManyFit(MoreBtnSize, maxSize, sizes);
        // done calculating
        this.setState({
          isChanging: false,
          hasMore:    true
        });
        headerActions.toggleMaxVisibleCategories(howManyFitIncludingMoreBtn, true);
      }
    }
  };

  howManyFit = (startSize, maxSize, sizes) => {
    let currentSize = startSize || 0;
    let i;
    /*
    check if all the menu items fit,
    but ignore the "More" button (the first of the list)
     */
    for (i = 0; i < sizes.length; ++i) {
      currentSize += sizes[i];
      if (currentSize >= maxSize) {
        return i;
      }
    }
    return i;
  };

  renderMoreBtn = (forceShow) => {
    if (forceShow || this.state.hasMore) {
      return <MoreBtn
        panel={this.props.panel}
        isActive={this.props.activeCategory === 'more'} />;
    }
  };

  renderCategories = (forceShow) => {
    // hide the categories while resizing
    if (!forceShow && this.state.isChanging) return;

    return this.props.categories.map((cat, idx) => {
      // skip the ones over the max elements
      if (!forceShow && idx >= this.props.maxVisibleCategories) return;

      return <Category
        key={cat.id}
        {...cat}
        panel={this.props.panel}
        isActive={cat.id === this.props.activeCategory} />;
    });
  };

  renderCustomNavigationItems = (forceShow) => {
    if (!forceShow && this.state.isChanging) return;

    // See if we have any
    if (!this.props.customNavigationItems) return;

    // Need to take the number of categories into account
    const categoryCount = this.props.categories.length;

    return this.props.customNavigationItems.map(function (item, idx) {
      // skip the ones over the max elements.
      /*
      Note: maxVisibleCategories includes the number of
      custom nav items that will fit as well
       */
      if (!forceShow && (categoryCount + idx) >= this.props.maxVisibleCategories) return;

      return <CustomNavigationItem key={idx} {...item} />;
    }, this);
  };

  render () {
    const listClass = this.state.isChanging
    ? 'majorcategories__list is-changing'
    : 'majorcategories__list';

    return (
      <nav className="majorcategories">
        <div className="majorcategories__inner">
          <ul ref="wrapperDIV" className={listClass} data-component="majorCategoryList">
            {this.renderCategories(false)}
            {this.renderCustomNavigationItems(false)}
            {this.renderMoreBtn(false)}
          </ul>
          <ul ref="hiddenDIV" className="majorcategories__list--hidden" style={{visibility: 'hidden'}}>
            {this.renderMoreBtn(true)}
            {this.renderCategories(true)}
            {this.renderCustomNavigationItems(true)}
          </ul>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/majorcategories/index.js